<!-- Mnge overlow croll roll -->

<template>
  <div 
    class="text-container"
    v-html="sauce">
  </div>
</template>

<script>
  export default {
    name: 'Text',

    props: {
      sauce: String,
    },
    data() {
      return {
      }
    },

    methods: {
    },

    mounted(){
    },
  }
</script>

<style scoped>
  .text-container {
    color: var(--dark);
    background-color: var(--light);
    width: 610px;
    height: 987px;
    display: flex;
    flex-direction: column;
    text-align: center;
    z-index: 2;
    padding: 1vh;

    overflow-y: auto;
  }

  /*mobile*/
  @media only screen and (max-width: 1200px){
    .text-container{
      width: 95%;
    }
  }
</style>
